import React, { useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { SvgCaretRight, Icon, SIZE } from '@tmapy/style-guide';

import './CatalogItem.sass';

import type { CatalogData } from '../types';
import { Tag } from './Tag';
import { Figure } from './Figure';
import { TypeBadge } from './TypeBadge';

type CatalogItemProps = {
  item: CatalogData;
};

export const CatalogItem: React.FC<CatalogItemProps> = React.memo(({ item }) => {
  const { image, description, keywords, title, type, uuid, type_description } = item;
  const navigate = useNavigate();

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
      // Only left mouse button
      if (event.button === 0) {
        navigate(`/${uuid}`);
        event.preventDefault();
      }
    },
    [navigate, uuid],
  );

  return (
    <article className='e-catalogItem sg-a-d-f' onMouseUp={handleClick}>
      <header className='sg-a-f-n sg-a-mr-4 sg-a-pt-2 sg-a-pb-2'>
        <div className='e-catalogItem--img'>
          <Figure src={image.url} color={image.color} type={type} />
        </div>
      </header>
      <div className='e-catalogItem--body sg-a-f-a sg-a-d-f sg-a-ai-c sg-a-pt-2 sg-a-pb-2'>
        <div className='sg-a-f-a sg-u-vs-1'>
          <Link to={`/${uuid}`} className='e-u-td-n'>
            <h2 className='e-catalogItem--title sg-a-mr-1'>{title}</h2>
          </Link>
          {description && (
            <div
              className='e-catalogItem--desc'
              dangerouslySetInnerHTML={{ __html: description }}
            ></div>
          )}
          <div className='e-catalogItem--tags'>
            {type && <TypeBadge type={type} label={type_description} />}
            {keywords?.map((keyword: string, idx: number) => <Tag key={idx} label={keyword} />)}
          </div>
        </div>
        <div className='e-catalogItem--arrow sg-a-f-n sg-a-ml-2'>
          <Link to={`/${uuid}`}>
            <Icon element={<SvgCaretRight />} size={SIZE.MED} />
          </Link>
        </div>
      </div>
    </article>
  );
});
